import { client } from './client';
import interceptors from './interceptors';

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getStatusSales() {
	return client.get("api/dashboard/status-sales-all", {
	});
}

function getTotalSales() {
	return client.get("api/dashboard/total-sales-all", {
	});
}

function getTotalPurchase() {
	return client.get("api/dashboard/total-purchase-all", {
	});
}

function getResumeStock(params) {
	return client.get("api/dashboard/stock-all", {
		params: {
			warehouse_id : params.warehouse_id,
			product_id : params.product_id
		},
	});
}

function getSalesProduct() {
	return client.get("api/dashboard/sales-all", {
	});
}

function getTopProduct() {
	return client.get("api/dashboard/top_five-all", {
	});
}

function getSalesPurchase(params) {
	return client.get("api/dashboard/resume_sales_purchase", {
		params: {
			warehouse_id : params,
		},
	});
}

function getSalesProductWeekly(params) {
	return client.get("api/dashboard/sales-weekly-all", {
		params: params,
	});
}

function getSalesPriceWeekly(params) {
	return client.get("api/dashboard/sales-price-weekly-all", {
		params: params,
	});
}

function getSalesRetailWeekly(params) {
	return client.get("api/dashboard/sales-retail-weekly-all", {
		params: params,
	});
}

function getSalesRetailPriceWeekly(params) {
	return client.get("api/dashboard/sales-retail-price-weekly-all", {
		params: params,
	});
}

export default {
	getStatusSales,
	getTotalSales,
	getTotalPurchase,
	getSalesProduct,
	getResumeStock,
	getTopProduct,
	getSalesPurchase,
	getSalesProductWeekly,
	getSalesPriceWeekly,
	getSalesRetailWeekly,
	getSalesRetailPriceWeekly,
}